import { Check, History } from "lucide-react";
import { UnavailableButton } from "./UnavailableButton";

export const PlanReviewFooter = ({ changeCount }: { changeCount: number }) => (
  <div className="flex flex-wrap items-center gap-3">
    <span className="text-sm text-black/60">
      Reviewing and submitting changes from this page is not available yet.
    </span>
    <span className="ml-auto flex gap-2">
      <UnavailableButton variant="outlined" startIcon={<History size={14} />}>
        Archive
      </UnavailableButton>
      <UnavailableButton variant="contained" startIcon={<Check size={14} />}>
        {changeCount
          ? `Submit all changes (${changeCount})`
          : "Submit all changes"}
      </UnavailableButton>
    </span>
  </div>
);
